import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import {Backdrop, Checkbox, FormControlLabel} from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import Cookies from "js-cookie";
import React from "react";
import {useTranslation} from "react-i18next";

import {useNavigate, useParams} from "react-router-dom";

import {REPORT_TYPES} from "../../constants";
import {createNewReport} from "../../services/requests/ApiRequests";
import {getCashById} from "../../services/requests/GraphRequests";
import RU from "../../services/translation/ru.json";
import {translation} from "../../services/translation/translation";
import {getQueryParams} from "../../utils";

export default function CashRegister() {
	const {t} = useTranslation();
	let navigate = useNavigate();
	let params = useParams();
	const {cashRegisterId = "", companyId = ""} = params || {};

	const [loading, setLoading] = React.useState(true);
	const [companyWithCash, setCompanyWithCash] = React.useState({});

	const [dict, setDict] = React.useState(RU);
	React.useEffect(() => {
		getCashById(Number(companyId))
			.then((data) => {
				const organization = data.data.organization;
				const filteredCashRegisters = organization.cashRegisters.filter(
					(cashRegister) =>
						cashRegister.id === parseInt(cashRegisterId)
				);

				const updatedOrganization = {
					...organization,
					cashRegisters: filteredCashRegisters,
				};

				setCompanyWithCash(updatedOrganization);
				setLoading(false);
			})

			.catch((error) => {
				console.warn(error);
				setLoading(false);
			});
		if (Cookies.get("simpalsid.lang")) {
			setDict(translation(Cookies.get("simpalsid.lang")));
		} else {
			setDict(translation("ru"));
		}
	}, [cashRegisterId, companyId]);

	const [openSuccess, setOpenSuccess] = React.useState(false);
	const [error, setError] = React.useState({
		status: false,
		msg: "Error",
	});
	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpenSuccess(false);
		setError({
			status: false,
			msg: "Error",
		});
	};

	function addTaxesNavigate() {
		navigate(`/acps/taxes/?cid=${companyId}&rid=${cashRegisterId}`);
	}

	function generateReport(type) {
		setLoading(true);
		const cashRegister = companyWithCash.cashRegisters[0];
		const card = {
			type: 3,
			name: companyWithCash.name,
			idnx: companyWithCash.idno,
			model: cashRegister.model,
			address: cashRegister.address,
			factory: cashRegister.factory,
			number: cashRegister.number,
			key: cashRegister.key,
			point: cashRegister.point,
		};
		const reqBody = {card, type};
		createNewReport(reqBody)
			.then((data) => {
				const reports = data.data?.data || [];
				if (reports.length) {
					// setLoading(true);
					// navigate(`/acps/report/${data.data.data[0].id}`);
					const newReport = reports.find(
						(report) => report?.soap_data?.type === type
					);

					window.open(
						`/acps/report/${newReport._id}?${getQueryParams(card)}`,
						"_blank"
					);
				} else {
					setError({
						status: true,
						msg: "There are errors while report generation",
					});
				}
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
				const data = error?.response?.data || {};
				const msg =
					data.error || "There are errors while report generation";
				setError({status: true, msg, code: error?.response?.status});
				setLoading(false);
			});
	}

	React.useEffect(() => {
		if (openSuccess && loading) {
			setTimeout(function () {
				getCashById(cashRegisterId).then((data) => {
					setCompanyWithCash(data.data.organization);
				});
				setLoading(false);
			}, 300);
		}
	}, [cashRegisterId, loading, openSuccess, setOpenSuccess]);

	if (loading) {
		return (
			<Grid sx={{marginTop: 4}}>
				<div align="center">
					<CircularProgress/>
				</div>
			</Grid>
		);
	}

	if (!companyWithCash || !companyWithCash.cashRegisters[0]) return null;
	const isSfsError = error.code === 450;
	const hasTaxes = companyWithCash.cashRegisters[0].taxes.length > 0;

	return (
		<>
			{error.status && isSfsError ? (
				<Backdrop open={error.status} sx={{zIndex: 99999}}>
					<Box
						style={{
							display: "flex",
							width: 500,
							alignItems: "center",
							flexDirection: "column",
							justifyContent: "center",
							backgroundColor: "#fff",
							padding: 16,
							borderRadius: 5,
						}}
					>
						<WarningAmberIcon color="error" sx={{fontSize: 40}}/>
						<p>{`${error.msg}`}</p>
						<Button
							onClick={() => setError({status: false, msg: ""})}
						>
							{t("retry")}
						</Button>
					</Box>
				</Backdrop>
			) : error.status ? (
				<Snackbar
					open={error.status}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="error"
						sx={{width: "100%"}}
					>
						{error.msg}
					</Alert>
				</Snackbar>
			) : null}

			<Box
				sx={{
					flexGrow: 1,
					marginTop: 3,
					marginLeft: 10,
					marginBottom: 10,
				}}
			>
				<Grid container sx={{marginTop: 2}} spacing={4} align="left">
					<Grid item xs={6}>
						<Typography
							sx={{fontSize: 24}}
							color="pimary"
							gutterBottom
						>
							EKassa
							№{" "}
							{companyWithCash.cashRegisters[0].id}
						</Typography>
						<Button
							variant="text"
							color="secondary"
							onClick={() => {
								navigate(`/company/${companyWithCash.id}`);
							}}
						>
							&#60; {dict.go_back}
						</Button>
						{/* Organization info */}
						<Grid container spacing={2} align="left">
							<Grid item xs={4}>
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									gutterBottom
								>
									{dict.org_name}:
								</Typography>
							</Grid>
							<Grid item xs={8}>
								<Typography
									sx={{fontSize: 14}}
									color="pimary"
									gutterBottom
								>
									{companyWithCash.name}
								</Typography>
							</Grid>
							<Grid item xs={4}>
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									gutterBottom
								>
									{dict.idno} :
								</Typography>
							</Grid>
							<Grid item xs={8}>
								<Typography
									sx={{fontSize: 14}}
									color="pimary"
									gutterBottom
								>
									{companyWithCash.idno}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={5} align="right">
						<Button
							variant="outlined"
							onClick={() => {
								navigate(
									`/edit-cash-register/${companyId}/${cashRegisterId}`
								);
							}}
						>
							{dict.edit_cash_register}
						</Button>
					</Grid>
				</Grid>
				<Grid container sx={{marginTop: 2}} spacing={4} align="left">
					<Grid item xs={12}>
						{(!hasTaxes && companyWithCash.cashRegisters[0].number) && (
							<Button
								variant="outlined"
								onClick={addTaxesNavigate}
								sx={{marginTop: 2, marginRight: 1}}
							>
								{t("add_taxes")}
							</Button>
						)}
						<Button
							variant="outlined"
							onClick={() => generateReport(REPORT_TYPES.Z)}
							sx={{marginTop: 2}}
							disabled={!hasTaxes}
						>
							{t("z_report")}
						</Button>
						<Button
							variant="outlined"
							onClick={() => generateReport(REPORT_TYPES.X)}
							sx={{marginTop: 2, marginLeft: 1}}
							disabled={!hasTaxes}
						>
							{t("x_report")}
						</Button>
					</Grid>
					<Grid item xs={5}>
						<TextField
							sx={{m: 1, width: "100%"}}
							id="Address"
							label={dict.address}
							value={companyWithCash.cashRegisters[0].address}
							variant="standard"
						/>

						<TextField
							sx={{m: 1, width: "100%"}}
							id="Model"
							label={dict.model}
							value={companyWithCash.cashRegisters[0].model}
							variant="standard"
						/>
						<TextField
							sx={{m: 1, width: "100%"}}
							id="Point"
							label={dict.point}
							value={companyWithCash.cashRegisters[0].point}
							variant="standard"
						/>
						<TextField
							sx={{m: 1, width: "100%"}}
							id="Point"
							label={dict.activity_type}
							value={companyWithCash.cashRegisters[0]?.activityType ? dict?.[`activity_${companyWithCash.cashRegisters[0]?.activityType.toLocaleLowerCase()}`] : ''}
							variant="standard"
						/>
						<FormControlLabel
							control={<Checkbox disabled/>}
							label="Disabled"
							checked={companyWithCash.cashRegisters[0].deleted}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							sx={{m: 1, width: "100%"}}
							id="Factory Number"
							label={dict.serial_number}
							value={companyWithCash.cashRegisters[0].factory}
							variant="standard"
						/>

						<TextField
							sx={{m: 1, width: "100%"}}
							id="Registration Number"
							label={dict.registration_number}
							value={companyWithCash.cashRegisters[0].number}
							variant="standard"
						/>

						<TextField
							sx={{m: 1, width: "100%"}}
							id="Key"
							label={dict.key}
							value={companyWithCash.cashRegisters[0].key}
							variant="standard"
						/>
						<TextField
							sx={{m: 1, width: "100%"}}
							id="Subdivision"
							label={dict.subdivision}
							value={companyWithCash.cashRegisters[0].subdivision}
							variant="standard"
						/>
					</Grid>
				</Grid>
				<Snackbar
					open={openSuccess}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="success"
						sx={{width: "100%"}}
					>
						Api key refreshed !
					</Alert>
				</Snackbar>
			</Box>
		</>
	);
}
